var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMnw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16 12.379-5.88-6.781c-.37-.29-1.37-.797-2.422-.52-1.052.277-1.568 1.545-1.695 2.145L1.056 25.87c-.092.276-.138.961.415 1.487.693.657 1.316.138 1.766-.277.36-.332 4.646-5.258 6.745-7.68 1.2 1.408 3.765 4.387 4.429 5.051.663.665 1.336.74 1.59.693.254.046.927-.028 1.591-.692.665-.663 3.23-3.642 4.43-5.05 2.097 2.422 6.385 7.348 6.744 7.68.45.415 1.073.934 1.764.277.554-.526.508-1.21.416-1.487L25.997 7.225c-.127-.6-.643-1.868-1.695-2.145-1.052-.277-2.052.23-2.421.519L16 12.378z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMnw);
export default __webpack_public_path__ + "static/media/MNW.f2fc643ac16f2afc37f94175b768457b.svg";
export { ForwardRef as ReactComponent };